(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cfc-directory"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__cfcDirModal) return;
    window.__cfcDirModal = true;

    var current = null;
    var lastFocus = null;

    function goTo(gal, index) {
      if (!gal) return;
      var count = parseInt(gal.getAttribute('data-cfc-gal-count'), 10) || 1;
      if (count < 2) return;
      var i = index % count;
      if (i < 0) i = count - 1;
      gal.setAttribute('data-cfc-gal-index', String(i));
      var track = gal.querySelector('[data-cfc-gal-track]');
      if (track) track.style.transform = 'translateX(' + (-100 * i) + '%)';
      var dots = gal.querySelectorAll('[data-cfc-gal-go]');
      for (var d = 0; d < dots.length; d++) {
        dots[d].setAttribute('aria-selected', d === i ? 'true' : 'false');
      }
    }

    function step(gal, dir) {
      if (!gal) return;
      var i = parseInt(gal.getAttribute('data-cfc-gal-index'), 10) || 0;
      goTo(gal, i + dir);
    }

    function openModal(id) {
      var modal = document.getElementById('cfc-dir-modal-' + id);
      if (!modal) return;
      if (current) closeModal();
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.classList.add('cfc-dir-locked');
      document.body.style.overflow = 'hidden';
      current = modal;
      goTo(modal.querySelector('[data-cfc-gal]'), 0);
      var close = modal.querySelector('.cfc-dir__modal-close');
      if (close) close.focus();
    }

    function closeModal() {
      if (!current) return;
      current.hidden = true;
      current = null;
      document.documentElement.classList.remove('cfc-dir-locked');
      document.body.style.overflow = '';
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      lastFocus = null;
    }

    document.addEventListener('click', function (e) {
      var target = e.target instanceof Element ? e.target : null;
      if (!target) return;

      var opener = target.closest('[data-cfc-dir-open]');
      if (opener) {
        e.preventDefault();
        openModal(opener.getAttribute('data-cfc-dir-open'));
        return;
      }

      var nav = target.closest('[data-cfc-gal-step]');
      if (nav) {
        e.preventDefault();
        step(nav.closest('[data-cfc-gal]'), parseInt(nav.getAttribute('data-cfc-gal-step'), 10));
        return;
      }

      var dot = target.closest('[data-cfc-gal-go]');
      if (dot) {
        e.preventDefault();
        goTo(dot.closest('[data-cfc-gal]'), parseInt(dot.getAttribute('data-cfc-gal-go'), 10));
        return;
      }

      if (target.closest('[data-cfc-dir-close]')) {
        e.preventDefault();
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') { closeModal(); return; }
      if (!current) return;
      var gal = current.querySelector('[data-cfc-gal]');
      if (!gal) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); step(gal, 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(gal, -1); }
    });

    /* Swipe tactile */
    var tx = 0, ty = 0, swiping = false;
    document.addEventListener('touchstart', function (e) {
      var target = e.target instanceof Element ? e.target : null;
      if (!target || !target.closest('[data-cfc-gal]')) { swiping = false; return; }
      swiping = true;
      tx = e.touches[0].clientX;
      ty = e.touches[0].clientY;
    }, { passive: true });

    document.addEventListener('touchend', function (e) {
      if (!swiping) return;
      swiping = false;
      var target = e.target instanceof Element ? e.target : null;
      var gal = target ? target.closest('[data-cfc-gal]') : null;
      if (!gal) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - tx;
      var dy = t.clientY - ty;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) step(gal, dx < 0 ? 1 : -1);
    }, { passive: true });

    /* Éditeur de thème */
    document.addEventListener('shopify:block:select', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('[data-cfc-dir-open]')) {
        openModal(e.detail.blockId);
      }
    });
    document.addEventListener('shopify:block:deselect', closeModal);
    document.addEventListener('shopify:section:unload', closeModal);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
